import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchLocationAreas: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'locationarea/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_LOCATIONAREA_REQUEST,
                        types.SEARCH_LOCATIONAREA_SUCCESS,
                        types.SEARCH_LOCATIONAREA_FAILURE
                    ]
                }
            });
        },

    saveLocationArea: (locationArea) =>
        (dispatch) => {
            if (locationArea.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationarea/create',
                        method: 'POST',
                        body: locationArea,
                        types: [
                            types.CREATE_LOCATIONAREA_REQUEST,
                            types.CREATE_LOCATIONAREA_SUCCESS,
                            types.CREATE_LOCATIONAREA_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationarea/update',
                        method: 'PUT',
                        body: locationArea,
                        types: [
                            types.UPDATE_LOCATIONAREA_REQUEST,
                            types.UPDATE_LOCATIONAREA_SUCCESS,
                            types.UPDATE_LOCATIONAREA_FAILURE
                        ]
                    }
                });
            }
        }
}
